import { Box, Card, Icon, Text, VStack } from "@chakra-ui/react";
import { useQuery } from "@tanstack/react-query";
import React, { useCallback } from "react";
import { Trans, useTranslation } from "react-i18next";
import { fetchCapture } from "../../api/vehicle";
import { useVehicle } from "../../hooks";
import { useAuth } from "../../../hooks";
import OccupiedIcon from "../common/icons/OccupiedIcon";
import NonOccupiedIcon from "../common/icons/NonOccupiedIcon";

const SeatCard = ({ occupant, row, seat }) => {
    const { t } = useTranslation();
    const { vehicle } = useVehicle();
    const { bearer } = useAuth();

    const captureFunction = useCallback(
        () => fetchCapture(vehicle?.VIN, row, seat, bearer),
        [vehicle?.VIN, row, seat, bearer],
    );

    const captureQuery = useQuery({
        queryKey: ["capture", row, seat],
        queryFn: captureFunction,
        enabled: occupant?.IsOccupied,
    });

    return (
        <Card width={"full"} height={"full"} backgroundColor={"#D2D2D233"} backdropFilter={"none"} boxShadow={"none"} borderRadius={"7px"} padding={"5px"}>
            <VStack width={"full"} height={"full"} gap={"10px"} justifyContent={"center"}>
                <Box width={"60px"} height={"60px"} backgroundColor={!occupant?.IsOccupied && "#848484"} borderRadius={"full"} display={"flex"} justifyItems={"center"} alignItems={"center"} justifyContent={"center"} alignContent={"center"} flexDirection={"row"}>
                    {occupant?.IsOccupied && captureQuery?.data ? (
                        <Box backgroundImage={`data:image/jpeg;base64,${captureQuery?.data}`} backgroundSize={"60px 60px"} width={"60px"} height={"60px"} borderRadius={"full"} borderColor={occupant?.Activity === "awake" ? "#0CC00C4D" : occupant?.Activity === "unconscious" ? "#FD2D2280" : "#80808080"} borderWidth={"5px"} borderStyle={"solid"} />
                    ) : (
                        <Icon as={occupant?.IsOccupied ? OccupiedIcon : NonOccupiedIcon} width={"60px"} height={"60px"} color={occupant?.IsOccupied ? "white" : "#B8BCBD"} />
                    )}
                </Box>
                {
                    occupant?.IsOccupied ? (
                        <VStack gap={"5px"}>
                            <Text fontSize={"16px"} fontWeight={500}>{t(`plugin.occupants.${occupant?.Age}`)}</Text>
                            <Text fontSize={"12px"} fontWeight={300}>{t(`plugin.occupants.${occupant?.Activity}`)}</Text>
                        </VStack>
                    ) : (
                        <Text fontSize={"16px"} fontWeight={500} color={"rgba(242,242,242,.3)"}>
                            <Trans>plugin.occupants.unoccupied</Trans>
                        </Text>
                    )}
            </VStack>
        </Card>
    );
}

export default React.memo(SeatCard);